import React from 'react';
import { useNavigate } from '../../../hooks';
import { DateTime } from 'luxon';
import { ModalContent } from '@amzn/atoz-web/Modal';
import { Button, ButtonVariant } from '@amzn/atoz-web/Button';
import { Text } from '@amzn/atoz-web/Text';
import { View } from '@amzn/atoz-web/View';
import { useTranslation } from 'react-i18next';
import { Routes } from '@amzn/atoz-shiftapp-initializer';
import { dateParam, goldModalRefValue, refParam } from '../../../config/queryParams';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
export var GoldModalContent = function (_a) {
    var close = _a.close;
    var navigate = useNavigate();
    var t = useTranslation().t;
    var handleButtonClick = function () {
        navigate("".concat(Routes.FindShifts, "?").concat(dateParam, "=").concat(DateTime.local().toISODate(), "&").concat(refParam, "=").concat(goldModalRefValue));
    };
    return (React.createElement(ModalContent, { dataTestId: "GoldModalContent", titleText: t('shift_management_features_GoldModalContent_title'), buttons: [
            React.createElement(Button, { key: "findShifts", dataTestId: "GoldModalContent__findShiftsButton", variant: ButtonVariant.Primary, onClick: handleButtonClick }, t('shift_management_features_GoldModalContent_findShiftsButton'))
        ], onCloseButtonClick: close, closeButtonAltText: t('shift_management_common_closeModalButton') },
        React.createElement(ViewSection, null, t('shift_management_features_GoldModalContent_intro')),
        React.createElement(ViewSection, null,
            React.createElement(Text, { fontWeight: "bold" }, t('shift_management_features_GoldModalContent_subtitle1')),
            React.createElement("ul", null,
                React.createElement("li", null,
                    React.createElement(Text, null, t('shift_management_features_GoldModalContent_subtext1'))))),
        React.createElement(ViewSection, null,
            React.createElement(Text, { fontWeight: "bold" }, t('shift_management_features_GoldModalContent_subtitle2')),
            React.createElement("ul", null,
                React.createElement("li", null,
                    React.createElement(Text, null, t('shift_management_features_GoldModalContent_subtext2')))),
            React.createElement(Text, null, t('shift_management_features_GoldModalContent_additionalInfo'))),
        React.createElement(ViewSection, null,
            React.createElement(Text, { fontWeight: "bold" }, t('shift_management_features_GoldModalContent_subtitle3')),
            React.createElement(Text, null, t('shift_management_features_GoldModalContent_subtext3')))));
};
export var ViewSection = styledWithTheme(View)(function (_a) {
    var theme = _a.theme;
    return "\n    margin-bottom: ".concat(theme.selectors.space('S400'), "px;\n");
});
